import {
  DateAndTime,
  getLocalTime,
  TimeQuestionConfig,
  TimeResponseState,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import {
  RoutineQuestionMessage,
  RoutineQuestionMessageProps,
} from '../../types';

export const TimeAndDateMessage: RoutineQuestionMessage<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
) => {
  const { t } = useTranslation();
  const { response } = props;
  const value =
    typeof response.timeTypeValue === 'object' && response.timeTypeValue !== null
      ? (response.timeTypeValue as DateAndTime)
      : undefined;
  const date = typeof value?.date === 'string' ? value.date : '-';
  const time = value?.time ? getLocalTime(value.time) : '-';

  return (
    <View>
      <Text style={props.textStyle}>
        {t('routines.time.message.date')}: {date}
      </Text>
      <Text style={props.textStyle}>
        {t('routines.time.message.time')}: {time}
      </Text>
    </View>
  );
};
